// document.addEventListener("DOMContentLoaded", function () {
//   initializeProductCards();
//   initializeInfiniteScroll();
//   initializeCartDrawer();
// });

// function initializeProductCards() {
//   const productCards = document.querySelectorAll(".product-card-wrapper");
//   productCards.forEach(initializeProductCard);

//   if (window.location.pathname.includes("/search")) {
//     productCards.forEach((card) => {
//       const defaultProductUrl = card.querySelector(".card__heading a")?.href;
//       if (defaultProductUrl) {
//         const cleanUrl = defaultProductUrl.split("?")[0];

//         updateVariantSelector(card, cleanUrl, true);
//       }
//     });
//   }
// }

// function initializeProductCard(productCard) {
//   const defaultProductUrl = productCard.querySelector(".card__heading a")?.href;
//   if (defaultProductUrl) {
//     const cleanUrl = defaultProductUrl.split("?")[0];
//     updateVariantSelector(productCard, cleanUrl);
//   }

//   const defaultColorSwatch = productCard.querySelector(
//     ".variant_color_swatches.select_variant"
//   );
//   if (defaultColorSwatch) {
//     defaultColorSwatch.classList.add("selected");
//     applySelectedEffect(defaultColorSwatch);

//     const productImage1 = productCard.querySelector(
//       ".card__media .product_image_1"
//     );
//     const productImage2 = productCard.querySelector(
//       ".card__media .product_image_2"
//     );

//     if (productImage1 && productImage2) {
//       if (
//         productImage2.src.includes("Liquid error") ||
//         productImage2.srcset.includes("Liquid error")
//       ) {
//         productImage2.src = productImage1.src;
//         productImage2.srcset = productImage1.srcset;
//       }
//     }
//   }

//   productCard.querySelectorAll(".variant_color_swatches").forEach((swatch) => {
//     swatch.addEventListener("click", function (e) {
//       e.preventDefault();
//       changeProductPLP(this);
//     });
//   });

//   const addToCartForm = productCard.querySelector(".product-form");
//   if (addToCartForm) {
//     addToCartForm.addEventListener("submit", handleAddToCart);
//   }
// }

// function initializeInfiniteScroll() {
//   const infiniteScrollElement = document.querySelector("infinite-scroll");
//   if (infiniteScrollElement) {
//     infiniteScrollElement.addEventListener("productsLoaded", function (event) {
//       const newProducts = event.detail.newProducts;
//       newProducts.forEach(initializeProductCard);
//     });
//   }
// }

// function initializeCartDrawer() {
//   const cartDrawer = document.querySelector("cart-drawer");
//   if (cartDrawer) {
//     if (!cartDrawer.open) {
//       cartDrawer.open = function () {
//         this.classList.add("animate", "active");
//         document.body.classList.add("overflow-hidden");
//       };
//     }

//     if (!cartDrawer.close) {
//       cartDrawer.close = function () {
//         this.classList.remove("active");
//         document.body.classList.remove("overflow-hidden");
//       };
//     }

//     const overlay = cartDrawer.querySelector("#CartDrawer-Overlay");
//     if (overlay) {
//       overlay.addEventListener("click", () => cartDrawer.close());
//     }
//   }
// }

// function changeProductPLP(element) {
//   const parent = element.closest(".product-card-wrapper");

//   if (!parent) {
//     console.error("No se encontró el contenedor del producto.");
//     return;
//   }

//   const baseUrl = window.location.origin;
//   const featureImageUrl1 = element.dataset.featureImage;
//   const featureImageUrl2 = element.dataset.featureImage2;
//   const productUrl = element.dataset.productUrl;
//   const productName = element.dataset.productName;

//   const productImage1 = parent.querySelector(".card__media .product_image_1");
//   const productImage2 = parent.querySelector(".card__media .product_image_2");
//   const currentInformation = parent.querySelectorAll(".card__heading a");

//   if (!productImage1 || !currentInformation.length) {
//     console.error("Elementos necesarios no encontrados.");
//     return;
//   }

//   const isValidSecondImage =
//     featureImageUrl2 &&
//     featureImageUrl2.trim() !== "" &&
//     !featureImageUrl2.includes("Liquid error");

//   updateProductImages(
//     productImage1,
//     productImage2,
//     featureImageUrl1,
//     isValidSecondImage ? featureImageUrl2 : null
//   );
//   updateProductInformation(currentInformation, productName, productUrl);
//   updateSelectedSwatch(parent, element);

//   const fullUrl = `${baseUrl}${productUrl}`;
//   const cleanUrl = fullUrl.split("?")[0];

//   fetch(cleanUrl + ".js")
//     .then((response) => response.json())
//     .then((product) => {
//       updatePriceDisplay(parent, product);
//     })
//     .catch((error) => {
//       console.error("Error al obtener información del producto:", error);
//     });

//   updateVariantSelector(parent, cleanUrl, true);
// }

// function updatePriceDisplay(parent, product) {
//   const variant =
//     product.variants.find((v) => v.available) || product.variants[0];
//   if (!variant) return;

//   const priceContainer = parent.querySelector(".price");
//   const regularPrice = parent.querySelector(".price-item--regular");
//   const salePrice = parent.querySelector(".price-item--sale");
//   const badge = parent.querySelector(".card__badge");

//   if (variant.compare_at_price && variant.compare_at_price > variant.price) {
//     priceContainer?.classList.add("price--on-sale");

//     if (regularPrice) {
//       regularPrice.style.display = "";
//       regularPrice.textContent = `$${formatPrice(variant.compare_at_price)}`;
//     }

//     if (salePrice) {
//       salePrice.style.display = "";
//       salePrice.textContent = `$${formatPrice(variant.price)}`;
//     }

//     updateDiscountBadge(badge, variant.price, variant.compare_at_price);
//   } else {
//     priceContainer?.classList.remove("price--on-sale");

//     if (regularPrice) {
//       regularPrice.style.display = "";
//       regularPrice.textContent = `$${formatPrice(variant.price)}`;
//     }

//     if (salePrice) {
//       salePrice.style.display = "none";
//     }

//     removeSaleBadge(badge);
//   }

//   updateSoldOutBadge(badge, variant.available);
// }

// function updateDiscountBadge(badgeContainer, price, comparePrice) {
//   if (!badgeContainer) return;

//   // Obtener el color scheme del badge original si existe
//   const existingSaleBadge = badgeContainer.querySelector(
//     ".color-badge-pinflag"
//   );
//   let colorSchemeClass = "";

//   if (existingSaleBadge) {
//     const colorClass = Array.from(existingSaleBadge.classList).find(
//       (className) =>
//         className.startsWith("color-") && className !== "color-badge-pinflag"
//     );
//     if (colorClass) {
//       colorSchemeClass = colorClass;
//     }
//     existingSaleBadge.remove();
//   }

//   const discount = comparePrice - price;
//   const discountPercentage = Math.round((discount / comparePrice) * 100);

//   const saleBadge = document.createElement("span");
//   saleBadge.classList.add("badge", "badge--bottom-left", "color-badge-pinflag");

//   // Añadir la clase de color si se encontró
//   if (colorSchemeClass) {
//     saleBadge.classList.add(colorSchemeClass);
//   }

//   saleBadge.textContent = `-${discountPercentage}%`;

//   badgeContainer.appendChild(saleBadge);
// }

// function removeSaleBadge(badgeContainer) {
//   if (!badgeContainer) return;

//   const saleBadge = badgeContainer.querySelector(".color-badge-pinflag");
//   if (saleBadge) {
//     saleBadge.remove();
//   }
// }

// function updateSoldOutBadge(badgeContainer, isAvailable) {
//   if (!badgeContainer) return;

//   const soldOutBadge = badgeContainer.querySelector(
//     ".badge:not(.color-badge-pinflag)"
//   );

//   if (!isAvailable) {
//     if (!soldOutBadge) {
//       const newSoldOutBadge = document.createElement("span");
//       newSoldOutBadge.classList.add("badge", "badge--bottom-left");
//       newSoldOutBadge.textContent = "Agotado";
//       badgeContainer.appendChild(newSoldOutBadge);
//     }
//   } else if (soldOutBadge) {
//     soldOutBadge.remove();
//   }
// }

// function formatPrice(price) {
//   return (price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
// }

// function updateProductImages(image1, image2, url1, url2) {
//   if (image1) {
//     image1.src = url1;
//     image1.srcset = url1;
//   }

//   if (image2) {
//     if (url2 && !url2.includes("Liquid error") && url2.trim() !== "") {
//       image2.style.display = "";
//       image2.src = url2;
//       image2.srcset = url2;
//     } else {
//       image2.style.display = "";
//       image2.src = url1;
//       image2.srcset = url1;
//     }
//   }
// }

// function updateProductInformation(infoElements, name, url) {
//   infoElements.forEach((element) => {
//     const desktopTitle = element.querySelector(".produt_title_desktop");
//     if (desktopTitle) {
//       desktopTitle.textContent = name;
//     }

//     const modelSpan = element.querySelector(".model-span");
//     const descriptionSpan = element.querySelector(".plp-description-span");

//     if (modelSpan) {
//       modelSpan.textContent =
//         element
//           .closest(".product-card-wrapper")
//           .querySelector(".variant_color_swatches.selected")?.dataset
//           .productModelo || "";
//     }

//     if (descriptionSpan) {
//       descriptionSpan.textContent =
//         element
//           .closest(".product-card-wrapper")
//           .querySelector(".variant_color_swatches.selected")?.dataset
//           .productPlpDescripcion || "";
//     }

//     element.href = url;
//   });
// }

// function updateSelectedSwatch(parent, selectedElement) {
//   parent.querySelectorAll(".variant_color_swatches").forEach((swatch) => {
//     swatch.classList.remove("select_variant", "selected");
//     const effect = swatch
//       .closest(".swatch_item")
//       ?.querySelector(".selected-effect");
//     if (effect) effect.remove();
//   });

//   selectedElement.classList.add("select_variant", "selected");
//   applySelectedEffect(selectedElement);
// }

// function applySelectedEffect(element) {
//   const parent = element.closest(".swatch_item");
//   if (parent) {
//     const existingEffect = parent.querySelector(".selected-effect");
//     if (existingEffect) existingEffect.remove();

//     const afterElement = document.createElement("div");
//     afterElement.classList.add("selected-effect");
//     parent.appendChild(afterElement);
//   }
// }

// function updateVariantSelector(parent, productUrl, forceUpdate = false) {
//   const variantSelector = parent.querySelector(".product-variant-selector");
//   const variantButtons = parent.querySelector(".variant-buttons");
//   const productForm = parent.querySelector(".product-form");
//   const selectedVariantInput = parent.querySelector(".selected-variant-id");
//   const submitButton = parent.querySelector(".product-variant-submit-button");
//   const soldOutMessage = parent.querySelector(".sold-out-message");

//   if (
//     !variantSelector ||
//     !variantButtons ||
//     !productForm ||
//     !selectedVariantInput
//   ) {
//     console.error(
//       "Elementos necesarios no encontrados para el selector de variantes."
//     );
//     return;
//   }

//   fetch(productUrl + ".js")
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
//       return response.json();
//     })
//     .then((product) => {
//       const availableVariants = product.variants.filter((v) => v.available);

//       if (availableVariants.length === 0) {
//         variantSelector.style.display = "none";
//         if (soldOutMessage) soldOutMessage.style.display = "flex";
//       } else {
//         if (soldOutMessage) soldOutMessage.style.display = "none";

//         renderVariantButtons(variantButtons, product.variants);

//         if (availableVariants.length > 0) {
//           selectVariant(parent, availableVariants[0].id);
//         }
//       }
//     })
//     .catch((error) => {
//       console.error("Error al cargar las variantes:", error);
//     });
// }

// function renderVariantButtons(container, variants) {
//   container.innerHTML = "";
//   variants.forEach((variant) => {
//     const button = createVariantButton(variant);
//     container.appendChild(button);
//   });
// }

// function createVariantButton(variant) {
//   const button = document.createElement("button");
//   button.type = "button";
//   button.classList.add("variant-button");
//   if (!variant.available) {
//     button.classList.add("unavailable");
//   }
//   button.textContent = variant.title.split("/")[0].trim();
//   button.dataset.variantId = variant.id;

//   button.addEventListener("click", function (e) {
//     e.preventDefault();
//     if (variant.available) {
//       selectVariant(this.closest(".product-card-wrapper"), variant.id);
//     }
//   });

//   return button;
// }

// function selectVariant(parent, variantId) {
//   const variantButtons = parent.querySelectorAll(".variant-button");
//   const selectedVariantInput = parent.querySelector(".selected-variant-id");
//   const submitButton = parent.querySelector(".product-variant-submit-button");

//   variantButtons.forEach((button) => {
//     button.classList.toggle(
//       "selected",
//       button.dataset.variantId === variantId.toString()
//     );
//   });

//   if (selectedVariantInput) selectedVariantInput.value = variantId;
//   if (submitButton) submitButton.disabled = false;

//   getVariantDetails(parent, variantId)
//     .then((selectedVariant) => {
//       if (selectedVariant) {
//         const colorSwatch = parent.querySelector(
//           `.variant_color_swatches[data-color="${selectedVariant.option1}"]`
//         );
//         if (colorSwatch) {
//           changeProductPLP(colorSwatch);
//         }
//       }
//     })
//     .catch((error) => {
//       console.error("Error al seleccionar la variante:", error);
//     });
// }

// function getVariantDetails(parent, variantId) {
//   const productUrl = parent.querySelector(".card__heading a")?.href;
//   if (!productUrl) return Promise.reject("URL del producto no encontrada");

//   const cleanUrl = productUrl.split("?")[0];

//   return fetch(cleanUrl + ".js")
//     .then((response) => {
//       if (!response.ok) {
//         throw new Error(`HTTP error! status: ${response.status}`);
//       }
//       return response.json();
//     })
//     .then((product) => {
//       return product.variants.find(
//         (v) => v.id.toString() === variantId.toString()
//       );
//     });
// }

// function handleAddToCart(event) {
//   event.preventDefault();
//   const form = event.target;
//   const submitButton = form.querySelector('[type="submit"]');
//   if (!submitButton) return;

//   const originalButtonText = submitButton.innerHTML;

//   submitButton.setAttribute("disabled", true);
//   submitButton.innerHTML = "<span>Añadiendo...</span>";

//   fetch("/cart/add.js", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(Object.fromEntries(new FormData(form))),
//   })
//     .then((response) => response.json())
//     .then((item) => {
//       updateCartDrawer(true);
//       updateCartIconBubble();
//     })
//     .catch((error) => {
//       console.error("Error al añadir al carrito:", error);
//     })
//     .finally(() => {
//       submitButton.removeAttribute("disabled");
//       submitButton.innerHTML = originalButtonText;
//     });
// }

function updateCartDrawer(openDrawer = false) {
  fetch("/?section_id=cart-drawer")
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(html, "text/html");
      const newDrawerContent = newDocument.querySelector(".drawer__inner");
      const cartDrawer = document.querySelector("cart-drawer");

      if (newDrawerContent && cartDrawer) {
        const currentDrawerContent = cartDrawer.querySelector(".drawer__inner");
        if (currentDrawerContent)
          currentDrawerContent.innerHTML = newDrawerContent.innerHTML;

        cartDrawer.classList.toggle(
          "is-empty",
          newDrawerContent.classList.contains("is-empty")
        );

        if (openDrawer) {
          cartDrawer.open();
        }
      }

      updateCartIconBubble();
    })
    .catch((error) => {
      console.error("Error al actualizar el carrito:", error);
    });
}

function updateCartIconBubble() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartIconBubble = document.querySelector("#cart-icon-bubble");
      if (cartIconBubble) {
        const itemCount = cart.item_count;
        const counterElement = cartIconBubble.querySelector(
          ".cart-count-bubble span"
        );

        if (counterElement) {
          counterElement.textContent = itemCount;
          counterElement
            .closest(".cart-count-bubble")
            ?.classList.toggle("hide", itemCount === 0);
        } else {
          const newCounterElement = document.createElement("div");
          newCounterElement.className = "cart-count-bubble";
          newCounterElement.innerHTML = `<span aria-hidden="true">${itemCount}</span><span class="visually-hidden">${itemCount} artículo(s)</span>`;
          cartIconBubble.appendChild(newCounterElement);
        }
      }
    })
    .catch((error) => {
      console.error("Error al actualizar el icono del carrito:", error);
    });
}

// // Función de debounce para optimizar las llamadas frecuentes
// function debounce(func, wait) {
//   let timeout;
//   return function executedFunction(...args) {
//     const later = () => {
//       clearTimeout(timeout);
//       func(...args);
//     };
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// }

// // Aplicar debounce a funciones que puedan ser llamadas frecuentemente
// const debouncedUpdateVariantSelector = debounce(updateVariantSelector, 300);
// const debouncedChangeProductPLP = debounce(changeProductPLP, 300);

// document.querySelectorAll(".swatch").forEach(function (swatch) {
//   swatch.addEventListener(
//     "click",
//     debounce(function () {
//       document.querySelectorAll(".swatch").forEach(function (item) {
//         item.classList.remove("swatch-selected");
//       });

//       this.classList.add("swatch-selected");
//     }, 300)
//   );
// });

// document.addEventListener("DOMContentLoaded", function (event) {
//   document.querySelectorAll(".color__container").forEach((div) => {
//     let isDragging = false,
//       startX,
//       scrollLeft;

//     div.addEventListener("mousedown", (e) => {
//       isDragging = true;
//       startX = e.pageX - div.offsetLeft;
//       scrollLeft = div.scrollLeft;
//       div.style.cursor = "grabbing";
//     });

//     div.addEventListener("mouseleave", () => {
//       isDragging = false;
//       div.style.cursor = "grab";
//     });

//     div.addEventListener("mouseup", () => {
//       isDragging = false;
//       div.style.cursor = "grab";
//     });

//     div.addEventListener("mousemove", (e) => {
//       if (!isDragging) return;
//       e.preventDefault();
//       const x = e.pageX - div.offsetLeft;
//       const walk = (x - startX) * 2; // Velocidad de desplazamiento
//       div.scrollLeft = scrollLeft - walk;
//     });
//   });

//   const filtersSelect = document.getElementById("ProductGridContainer");
//   const config = { childList: true, subtree: true };
//   // Crear el observer
//   const observer = new MutationObserver((mutationsList) => {
//     mutationsList.forEach((mutation) => {
//       if (mutation.type === "childList") {
//         document.querySelectorAll(".color__container").forEach((div) => {
//           let isDragging = false,
//             startX,
//             scrollLeft;

//           div.addEventListener("mousedown", (e) => {
//             isDragging = true;
//             startX = e.pageX - div.offsetLeft;
//             scrollLeft = div.scrollLeft;
//             div.style.cursor = "grabbing";
//           });

//           div.addEventListener("mouseleave", () => {
//             isDragging = false;
//             div.style.cursor = "grab";
//           });

//           div.addEventListener("mouseup", () => {
//             isDragging = false;
//             div.style.cursor = "grab";
//           });

//           div.addEventListener("mousemove", (e) => {
//             if (!isDragging) return;
//             e.preventDefault();
//             const x = e.pageX - div.offsetLeft;
//             const walk = (x - startX) * 2; // Velocidad de desplazamiento
//             div.scrollLeft = scrollLeft - walk;
//           });
//         });
//       }
//     });
//   });

//   // Configurar el observer
//   observer.observe(filtersSelect, config);
// });
// function updateSelectedVariant(button, cart = false) {
//   if (!cart) {
//     const productCard = button.closest(".product-card-wrapper");
//     const selectedVariantId = button.dataset.variantId;
//     const hiddenVariantInput = productCard.querySelector(
//       ".selected-variant-id"
//     );
//     hiddenVariantInput.value = selectedVariantId;

//     const variantButtons = productCard.querySelectorAll(".variant-button");

//     variantButtons.forEach((btn) => {
//       btn.classList.toggle(
//         "selected",
//         btn.dataset.variantId === selectedVariantId
//       );
//     });
//   } else {
//     const cartItem = button.closest(".cart-recommendations-cart-item ");

//     const selectedVariantId = button.dataset.variantId;

//     const hiddenVariantInput = cartItem.querySelector(
//       ".cart-recommendations-form-hidden"
//     );

//     hiddenVariantInput.value = selectedVariantId;

//     const variantButtons = cartItem.querySelectorAll(".variant-button");

//     variantButtons.forEach((btn) => {
//       btn.classList.toggle(
//         "selected",
//         btn.dataset.variantId === selectedVariantId
//       );
//     });
//   }
// }
